import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.98 20.5c-2.165 0-4.052-.713-5.66-2.139C4.71 16.936 3.783 15.15 3.54 13h1.531c.253 1.727 1.03 3.159 2.332 4.295C8.705 18.432 10.23 19 11.98 19c1.95 0 3.604-.68 4.962-2.038C18.301 15.604 18.98 13.95 18.98 12c0-1.95-.68-3.604-2.038-4.963C15.585 5.68 13.931 5 11.981 5a6.685 6.685 0 0 0-3.071.728A7.558 7.558 0 0 0 6.442 7.73h2.616v1.5H3.98V4.154h1.5v2.37a8.488 8.488 0 0 1 2.915-2.23A8.368 8.368 0 0 1 11.98 3.5a8.24 8.24 0 0 1 3.315.67 8.608 8.608 0 0 1 2.696 1.818 8.605 8.605 0 0 1 1.82 2.697A8.252 8.252 0 0 1 20.48 12c0 1.18-.223 2.285-.67 3.315a8.606 8.606 0 0 1-1.819 2.697 8.606 8.606 0 0 1-2.696 1.819 8.255 8.255 0 0 1-3.315.669m3.003-4.473-3.723-3.723V7h1.5v4.696l3.277 3.277z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }